import React from "react";
import useLocales from "../../../hooks/useLocales";

const QrImageCard = ({ item, styles }) => {
  const { translate } = useLocales();
  const coloum_value = JSON.parse(item?.coloum_value);
  const fonts = styles?.filter((item) => item.coloum_name === "fonts")?.[0];
  const fontValue = fonts?.coloum_value && JSON.parse(fonts?.coloum_value);
  return (
    <div className="bg-white m-0 rounded-[16px] flex flex-col items-center">
      <img
        src={coloum_value?.qr}
        className="m-0 rounded-[16px] w-[139px] max-w-[139px] min-w-[139px] h-[139px] max-h-[139px] min-h-[139px] md:w-[185px] md:max-w-[185px] md:min-w-[185px] md:h-[185px] md:max-h-[185px] md:min-h-[185px]"
        alt="qrCode" title="Qr Code"
      />
      <div className="p-[15px] pt-0">
        <p style={{ color: fontValue?.fontColor, fontFamily: fontValue?.fontType?.value }} className={` text-small3 md:text-small1 text-center font-${fontValue?.fontType?.value}`}>
          {/* Scan QR Code */}{translate("cms.scan_qr_code")}
        </p>
      </div>
    </div>
  );
};

export default QrImageCard;
